import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";
import { LocalizationType } from "types/Catalogs";
import { CurrencyType } from "types/Currency";
import { LanguageType } from "types/localization";

interface ICatalogsStore {
  currencies: CurrencyType[] | null;
  languages: LanguageType[] | null;
  localization: LocalizationType[] | null;
  isCurrenciesLoaded: boolean;
  isLanguagesLoaded: boolean;
  isLocalizationLoaded: boolean;
  setCurrencies: (currencies: CurrencyType[]) => void;
  setLanguages: (languages: LanguageType[]) => void;
  setLocalization: (localization: LocalizationType[]) => void;
}

export const useCatalogsStore = createWithEqualityFn<ICatalogsStore>()(
  devtools(
    (set) => ({
      currencies: null,
      languages: null,
      localization: null,
      isCurrenciesLoaded: false,
      isLanguagesLoaded: false,
      isLocalizationLoaded: false,
      setCurrencies: (currencies) =>
        set({ currencies, isCurrenciesLoaded: true }),
      setLanguages: (languages) => set({ languages, isLanguagesLoaded: true }),
      setLocalization: (localization) =>
        set({ localization, isLocalizationLoaded: true }),
    }),
    { name: "Catalogs Store" },
  ),
  shallow,
);
